import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import About from './pages/AboutUs';
import Products from "./pages/Products";
import Product from './pages/Product';
import Profile from './pages/Profile';
import Cart from './pages/Cart';
import Address from './pages/Address';
import Checkout from './pages/Checkout';
import Favorites from './pages/Favorites';
import { Provider } from "react-redux";
import Store from "./redux/Store";
import Addproduct from './pages/Addproduct';
import UpdateProduct from './pages/UpdateProducts';
import BuyesDetails from './pages/BuyersDetails';
import SellersOrders from './pages/SellersOrders';
import DeleteUser from './pages/DeleteUser';




const App = () => {
  return (
    <Router>
      <Provider store={Store}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product-detail/:id" element={<Product />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/address" element={<Address />} />
        {/* <Route path="/checkout" element={<Checkout />} /> */}
        <Route path="/order-history" element={<SellersOrders />} />
        {/* <Route path="/order-history" element={<OrderHistory />} /> */}
        <Route path="/buyers-details/:id" element={<BuyesDetails/>} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/addproduct" element={<Addproduct />} />
        <Route path="/update-product/:id" element={<UpdateProduct />} />
        <Route path="/delete-user" element={<DeleteUser />} />
      </Routes>
      </Provider>
      <Toaster/>
    </Router>
  );
};

export default App;
